var _path, _circle, _circle2, _g, _circle3, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEncouragement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 123,
    viewBox: "0 0 146 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Award 3",
    filter: "url(#filter0_d_3684_50686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medal"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M70.8985 4.26841C72.7022 2.71931 75.3668 2.71931 77.1706 4.26841L79.7372 6.47264C81.1386 7.67623 83.0287 8.14209 84.829 7.72765L88.1259 6.96865C90.443 6.43524 92.8024 7.67355 93.6796 9.88346L94.9278 13.028C95.6094 14.745 97.0665 16.0358 98.8532 16.5055L102.125 17.3656C104.425 17.9701 105.938 20.163 105.688 22.5275L105.332 25.8919C105.138 27.7289 105.828 29.5491 107.192 30.7952L109.689 33.0774C111.444 34.6813 111.766 37.3265 110.445 39.3038L108.566 42.1174C107.541 43.6537 107.306 45.5861 107.934 47.3233L109.085 50.5047C109.894 52.7406 108.949 55.2321 106.861 56.3693L103.89 57.9874C102.268 58.871 101.162 60.4731 100.911 62.3033L100.452 65.6552C100.129 68.0108 98.1341 69.7778 95.7568 69.8144L92.374 69.8664C90.5268 69.8949 88.8032 70.7995 87.7305 72.3035L85.766 75.0579C84.3854 76.9937 81.7982 77.6314 79.6761 76.5589L76.6566 75.033C75.0079 74.1998 73.0612 74.1998 71.4124 75.033L68.3929 76.5589C66.2709 77.6314 63.6837 76.9937 62.3031 75.0579L60.3386 72.3035C59.2659 70.7995 57.5422 69.8949 55.6951 69.8664L52.3123 69.8144C49.9349 69.7778 47.9404 68.0108 47.6175 65.6552L47.1581 62.3033C46.9072 60.4731 45.8014 58.871 44.1791 57.9874L41.208 56.3693C39.1199 55.2321 38.175 52.7406 38.9838 50.5047L40.1347 47.3233C40.7631 45.5861 40.5285 43.6537 39.5026 42.1174L37.6238 39.3038C36.3034 37.3265 36.6246 34.6813 38.3798 33.0774L40.8773 30.7952C42.2411 29.5491 42.9314 27.7289 42.737 25.8919L42.3809 22.5275C42.1307 20.163 43.6443 17.9701 45.9439 17.3656L49.2159 16.5055C51.0026 16.0358 52.4596 14.745 53.1412 13.028L54.3895 9.88345C55.2667 7.67354 57.6261 6.43524 59.9431 6.96865L63.2401 7.72765C65.0404 8.14209 66.9304 7.67623 68.3319 6.47264L70.8985 4.26841Z",
    fill: "url(#paint0_linear_3684_50686)",
    stroke: "#665000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 73.7747,
    cy: 40.306,
    r: 28.0638,
    fill: "#785E03"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3684_50686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 16,
    width: 54,
    height: 54
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 75.3112,
    cy: 43.108,
    r: 26.4616,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3684_50686)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 73.7747,
    cy: 40.3099,
    r: 28.0638,
    fill: "#8A6B1B"
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 74.5496,
    cy: 40.0515,
    r: 22.657,
    fill: "#B3881C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75.2265 23.0137L74.3321 21.2249L73.4376 23.0137L68.4888 32.9114L58.6435 34.142L56.7507 34.3786L58.022 35.8008L64.8432 43.4312L62.97 54.4219L62.6385 56.3666L64.403 55.4844L74.3321 50.5198L84.2612 55.4844L86.0224 56.365L85.6944 54.4234L83.8375 43.4311L90.6429 35.7999L91.9106 34.3783L90.0206 34.142L80.1753 32.9114L75.2265 23.0137Z",
    fill: "url(#paint1_linear_3684_50686)",
    stroke: "#AE8620",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Banner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25",
    d: "M36.9551 74.5508L36.9551 106.992L3.99942 106.992L13.6712 90.7711L3.99942 74.5508L36.9551 74.5508Z",
    fill: "#983535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M109.045 74.5508L109.045 106.992L142.001 106.992L132.329 90.7711L142.001 74.5508L109.045 74.5508Z",
    fill: "#983535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34",
    d: "M27.6855 83.3046L36.9543 74.5508V114.201H27.6855V83.3046Z",
    fill: "#752727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 35",
    d: "M118.314 83.8196L109.046 74.5508V114.201H118.314V83.8196Z",
    fill: "#752727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 33",
    x: 27.6855,
    y: 83.8203,
    width: 90.6281,
    height: 30.381,
    fill: "#CE4444"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3684_50686",
    x: 0,
    y: 2.60742,
    width: 146,
    height: 119.594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3684_50686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3684_50686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3684_50686",
    x1: 74.0345,
    y1: 0.916016,
    x2: 74.0345,
    y2: 80.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD12E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3684_50686",
    x1: 74.3321,
    y1: 23.4609,
    x2: 74.3321,
    y2: 54.5899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE86D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncouragement);
export default __webpack_public_path__ + "static/media/Encouragement.5592b2c76e4267842b14d8e602d48f1e.svg";
export { ForwardRef as ReactComponent };